<template>
  <div class="container">
    <div class="case-panel" ref="casePaneRef">
      <div class="case-panel-body">
        <div class="case-filter">
          <el-tag
            type="danger"
            effect="plain"
            v-for="(item, index) in tagList"
            :key="'tagList' + index"
            closable
            @close="changeTagItem(item)"
            :disable-transitions="true"
            >{{ item.name }}：{{ item.value }}</el-tag
          >
          <el-button v-show="tagList.length > 3" @click="clearGroup" type="text">清空</el-button>
        </div>

        <el-form label-position="right" ref="caseLabel" label-width="120px">
          <el-form-item class="caseLabel-form" v-for="label in filterList" :key="label.name" :label="label.name">
            <!-- input - text -->
            <template v-if="label.inputType == 'inputText'">
              <el-input
                v-model="label.value"
                :name="label.key"
                :clearable="label.clearable"
                :placeholder="label.placeholder"
                @input="label.value = label.value.replace(/\s+/g, ' ')"
              />
            </template>

            <!-- select - normal -->
            <template v-if="label.inputType == 'select'">
              <el-select
                style="width: 100%;"
                v-model="label.value"
                :multiple="label.mulits"
                :filterable="label.filterable"
                :clearable="label.clearable"
                :collapse-tags="label.collapseTags"
                :placeholder="label.placeholder"
              >
                <el-option
                  v-for="item in selectData[label.key]"
                  :key="item.key"
                  :label="item.keyAsString"
                  :value="item.keyAsString"
                >
                </el-option>
              </el-select>
            </template>

            <template v-if="label.key == 'publishMachinery'">
              <configureTreeSelect :ref="label.key" :item="label" @valueChange="treeSelectChange" />
            </template>

            <template v-if="['category', 'classification'].includes(label.key)">
              <loadedTreeSelect
                :ref="label.key"
                :item="label"
                :selectData="selectData[label.key]"
                @valueChange="treeSelectChange"
              />
            </template>
            <!-- date -  -->
            <template v-if="label.inputType == 'date'">
              <el-date-picker
                style="width: 100%;"
                v-model="label.value"
                value-format="yyyy-MM-dd"
                class="caseLabel-form-date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </template>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="normal-footer">
      <el-button @click="clearGroup" :style="{ background: '#fff' }">
        <span>重置条件</span>
      </el-button>
      <el-button type="primary" @click="emitConfirm">
        <span>立即检索</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import { services } from '@/service';
import { cloneDeep } from 'lodash';
import { lawOptionFilterList } from '@/constant';

import configureTreeSelect from '@/components/configureTreeSelect';
import loadedTreeSelect from '@/components/loadedTreeSelect';

import publicUtilFunc from '@/common/js/publicUtil';
const publicUtil = publicUtilFunc();

export default {
  components: { configureTreeSelect, loadedTreeSelect },
  data() {
    return {
      filterList: cloneDeep(lawOptionFilterList),
      categoryVal: '',
      categoryTreeFlag: false,
      categoryTreeEnterFlag: false,
      categoryTreeFocusFlag: false,
      categoryDelFlag: false,
      queryList: {},
      selectData: {}
    };
  },
  computed: {
    tagList() {
      return publicUtil.getLawTagList(this.filterList);
    }
  },
  async mounted() {
    if (this.$route.name != 'lawDetail' && this.$route.name != 'fullText') {
      this.getLawOptionSelect();
    }

    if (this.$route.name == 'mainSearch') {
      sessionStorage.removeItem('lawCaseFilterObj');
      sessionStorage.removeItem('lawCaseSearchTitle');
      this.clearGroup();
    }
  },

  methods: {
    treeSelectChange(item, value) {
      item.value = value;
    },
    // 变更某项检索条件
    changeTagItem(item) {
      if (item.type === 'query') return (this.queryList[item.key] = '');
      const curItem = this.filterList.find(curItem => item.key == curItem.key);
      if (curItem) {
        const { type, value } = curItem;
        if (type === 'string') {
          curItem.value = value
            .split(' ')
            .filter(o => o !== item.value)
            .join(' ');
        } else if (type === 'array') {
          curItem.value = value.filter(o => o !== item.value);
        } else if (type === 'array-tree') {
          curItem.value = value.filter(o => o.id !== item.id);
        } else if (type === 'date') {
          curItem.value = [];
        }
      }
    },
    // 处理不同类型的返回值
    valueHandel(item, curItem) {
      function isString(item, value) {
        const arr = value.split(' ');
        arr.splice(item.index, 1);
        return arr.join(' ');
      }
      function isDate() {
        return [];
      }
      function isArray(item, value) {
        let resValue = [...value];
        if (item.index === undefined) {
          resValue.push(item);
          resValue = _.uniqBy(resValue, 'name');
        } else {
          resValue.splice(item.index, 1);
        }
        return resValue;
      }
      const typeMap = {
        string: isString,
        date: isDate,
        array: isArray,
        'array-tree': isArray
      };
      const { value, type } = curItem;
      return typeMap[type](item, value);
    },
    caseLabelTree(bool) {
      if (!bool) {
        this.categoryTreeFlag = false;
      }
      this.categoryTreeFlag = this.categoryTreeFocusFlag ? true : false;
      this.categoryTreeEnterFlag = bool;
    },
    emitConfirm() {
      sessionStorage.setItem('lawOptionFilterList', JSON.stringify(this.filterList));
      const searchTextList = this.tagList.map(groupItem => groupItem.value).filter(text => !!text);
      services.logger.handleLog({ operateName: '法规高级检索', otherParams: { info: searchTextList } }, '法规');
      this.$emit('lawfilterEmit');
      // this.$router.push({
      //   path: "/law/midpage"
      // });
    },
    categoryKeydown() {
      const categoryNodes = this.$refs.caseLabelTree[0].$el.getElementsByClassName('el-tree-node__content');
      const categoryVal = this.categoryVal;

      Array.prototype.forEach.call(categoryNodes, function(item) {
        if (categoryVal) {
          if (item.innerText.indexOf(categoryVal) < 0) {
            item.style.display = 'none';
          }
        } else {
          item.style.display = 'flex';
        }
      });
    },
    categoryTreeHide(bool) {
      this.categoryTreeFocusFlag = bool;
      if (!bool) {
        setTimeout(() => {
          if (!this.categoryTreeEnterFlag) {
            this.categoryTreeFlag = false;
          }
        }, 400);
      } else {
        this.categoryTreeFlag = true;
      }

      this.$nextTick(() => {
        let boxHeight = this.$refs.selectbox[0].clientHeight;
        this.$refs.caseLabelFormTree[0].style.top = parseInt(boxHeight) + 10 + 'px';
      });
    },
    categoryDelFn(bool) {
      this.categoryDelFlag = bool;
      if (!this.categoryVal) {
        this.categoryDelFlag = false;
      }
    },
    selectboxDel() {
      this.categoryVal = '';
      this.categoryDelFlag = false;
    },
    // 处理数组结构
    handleBucketsArr(key, arr) {
      let newArr = [];
      arr.forEach(item => {
        if (item[key] && item[key].buckets) {
          item.children = item[key].buckets;
        }
        newArr.push(item);
      });

      return newArr;
    },
    // 获取参数列表
    async getLawOptionSelect() {
      try {
        const {
          category: { buckets: category },
          status: { buckets: status },
          collect_status: { buckets: collect_status },
          full_classification: { buckets: full_classification }
        } = await services.courseware.getLawOptionSelect();

        const selectData = {
          status,
          collect_status,
          category: this.handleBucketsArr('level', category),
          classification: this.handleBucketsArr('children', full_classification)
        };

        this.selectData = Object.freeze(selectData);

        // 后面右侧数要用到category的id
        localStorage.setItem('category', JSON.stringify(selectData.category));
      } catch (err) {
        console.error(err);
      }
    },
    initSelect() {
      const lawOptionFilterList = sessionStorage.getItem('lawOptionFilterList');
      this.filterList = lawOptionFilterList ? JSON.parse(lawOptionFilterList) : cloneDeep(lawOptionFilterList);
    },
    // 重置表单
    resetHandle() {
      this.filterList.forEach(i => {
        i.value = Array.isArray(i.value) ? [] : '';
      });
    },
    // 清空条件
    clearGroup() {
      this.queryList = {};
      this.resetHandle();
    }
  }
};
</script>
<style lang="less">
.law-pop-select {
  max-width: 500px;

  .el-select-dropdown__item {
    line-height: 22px;
    padding: 10px;
    height: auto;
  }
}
</style>
<style lang="less" scoped>
@menuWidth: 360px;

.container {
  box-sizing: border-box;
  position: relative;
}

/deep/ .case-panel {
  padding: 20px 0 16px;

  // overflow-y: auto;
  // overflow-x: hidden;
  .case-panel-body {
    color: #2c3443;

    .desc {
      margin-bottom: 18px;

      .label {
        font-size: 16px;
        margin-right: 10px;
      }

      .word {
        font-size: 12px;
        color: #77839e;
      }
    }
  }

  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    clear: both;
  }
}

.caseLabel-form {
  width: 50%;
  float: left;
  box-sizing: border-box;
  padding: 0 50px;

  /deep/ .el-input__inner {
    border-radius: 4px;
    color: #222;
  }

  /deep/ .el-form-item__label {
    font-size: 16px;
    color: #222;
    padding-right: 14px;
  }

  /deep/ .el-select__input {
    border: none !important;
  }

  /deep/ .el-select .el-tag__close.el-icon-close {
    background: #c0c4cc;
  }

  /deep/ .el-form-item__content {
    line-height: 0;
  }

  .caseLabel-form-selecttree {
    position: relative;
    z-index: 100;

    .caseLabel-form-selectbox {
      position: relative;
      border: 1px solid #dcdfe6;
      border-radius: 4px;

      .caseLabel-form-selectbox-item {
        flex-grow: 1;
      }

      /deep/ .el-input__inner {
        border: none;
      }

      .caseLabel-form-selectbox-item-key {
        display: contents;

        .selectbox-item {
          margin: 2px 0 2px 6px;
          height: 24px;
          padding: 0 8px;
          display: inline-block;
          line-height: 24px;
          border-radius: 4px;
          background: #e9e9eb;
          color: #222222;
          font-size: 12px;

          .el-icon-close {
            margin-left: 2px;
            background: #c0c4cc;
            color: #909399;
            border: none;
            border-radius: 50%;
            cursor: pointer;
            vertical-align: text-top;

            &:hover {
              color: #fff;
            }
          }
        }
      }

      .caseLabel-form-selectbox-del {
        position: absolute;
        right: 15px;
        width: 20px;
        text-align: center;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        transform: rotateZ(0deg);
        transition: 0.4s;

        &.search-active {
          transform: rotateZ(180deg);
          transition: 0.4s;
        }
      }

      .caseLabel-form-select-item {
        float: left;
        margin: 2px 0 2px 6px;
        padding: 2px 5px;
        font-size: 12px;
        background: #e6e6e6;
        height: 23px;
        line-height: 23px;
        border-radius: 3px;

        i {
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }

    .caseLabel-form-tree {
      position: absolute;
      max-height: 250px;
      top: 50px;
      // padding: 10px;
      overflow-y: auto;
      box-sizing: border-box;
      border: 1px solid #e6e6e6;
      border-radius: 3px;
      width: 100%;
      background: #fff;

      .custom-tree-node {
        width: 100%;
        padding: 13px 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: block;
      }
    }
  }

  .caseLabel-form-date-wrap {
    display: flex;

    .caseLabel-form-date-span {
      // flex: 0 0 40px;
      text-align: center;
    }

    // .caseLabel-form-date {
    //   flex: 1;
    // }
  }
}

.case-filter {
  margin: 0px 50px 10px;

  > span {
    margin: 0 16px 10px 0;
    font-size: 14px;
  }
}

.normal-footer {
  text-align: center;
  line-height: 35px;
  border-top: 1px solid #e6e6e6;
  clear: both;
  padding: 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/law/lawfilter.vue